import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import { delect } from './reducers';

class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    handleDelete = async record => {
        this.props.delect(record)
            .then(() => {
                this.props.asyncGet();
            });
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Popconfirm title="是否删除?" onConfirm={() => {
                    this.handleDelete(record);
                }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    render() {
        let { list, uiStatus, pagination } = this.props;
        let { isLoading } = uiStatus;

        const columns = [
            {
                title: '上传日期',
                dataIndex: 'date',
                key: 'date',
            },
            {
                title: '文件名',
                dataIndex: 'fileName',
                key: 'fileName',
            },
            {
                title: '文件路径',
                dataIndex: 'filePath',
                key: 'filePath',
            },
            {
                title: 'md5',
                dataIndex: 'md5',
                key: 'md5',
            },
            {
                title: '文件大小',
                dataIndex: 'size',
                key: 'size',
                render: text => {
                    let temp = parseInt(text);
                    if (temp > 1024 * 1024 * 1024 ) {
                        return <span>{(temp / 1024 / 1024 / 1024).toFixed(2)} GB</span>;
                    } else if (temp > 1024 * 1024 ) {
                        return <span>{(temp / 1024 / 1024).toFixed(2)} MB</span>;
                    } else if (temp > 1024 ) {
                        return <span>{(temp / 1024).toFixed(2)} KB</span>;
                    } else {
                        return <span>{(temp).toFixed(2)} B</span>;
                    }
                },
            },
            {
                title: '下载地址',
                dataIndex: 'url',
                key: 'url',
                render: text => {
                    return <a href={text} target="_blank">{text}</a>;
                },
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        onChange={this.changeHandle}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.fileList.selectedContent,
    list: state.fileList.list,
    pagination: state.fileList.pagination,
    proxyrepeatinfo: state.fileList.proxyrepeatinfo,
    uiStatus: state.fileList.uiStatus,
    agentsGroup: state.fileList.agentsGroup,
    transferData: state.fileList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/fileList/index.js